export default "__VITE_ASSET__84EadG3Y__"